import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {

  transform(t: string): string {


    let res;

    switch ( t){
      case "folder":
        res = "Dossier";
        break;

        case "png":
          res = "Image png";
          break;

          case "mp4":
            res = "Vidéo .mp4";
            break;

            case "pdf":
              res = "Document PDF";
              break;


              case "quiz":
                res = "Questionnaire";
                break;


      default:
        break;
    }



    return res;


  }


}
